import {createAsyncThunk} from '@/app/store/createAsyncThunk';
import {Preferences} from '@/app/interfaces/preferences';

export const updatePreferencesAction = createAsyncThunk<Partial<Preferences>, Partial<Preferences>, void>(
	'config/updatePreferences',
	async (newPreferences, {context, success}) => {
		await context.backendAPI.config.setPreferences(newPreferences);
		return success(newPreferences);
	},
);
